import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { SignInPageBlueprint } from '@backstage/plugin-app-react';
import { dexAuthApi, dexAuthApiRef } from './dexAuthApi';

const signInPage = SignInPageBlueprint.make({
  params: {
    loader: async () => {
      const { SignInPage } = await import('@backstage/core-components');
      return props => (
        <SignInPage
          {...props}
          provider={{
            id: 'dex-auth-provider',
            title: 'Greenstep SSO',
            message: 'Sign in using Dex',
            apiRef: dexAuthApiRef,
          }}
        />
      );
    },
  },
});

export const signInPageModule = createFrontendModule({
  pluginId: 'app',
  extensions: [signInPage, dexAuthApi],
});
